module.exports = __webpack_public_path__ + "img/eye-solid.4e9c32fd.svg";